import { useState } from 'react'
import { ventures, venture } from '../../../config'

const ventureGeoRedirects = {
  ca: {
    monopolycasino: {
      redirectPrompt: 'Looks like you’re visiting from Canada. For the best experience, check out our dedicated MONOPOLY Casino Canada site.',
      redirectTo: `${ventures.monopolycasinoca?.urls?.url}/?acquisition-channel=referral`,
      redirectButton: 'GO TO CANADA'
    },
    monopolycasinous: {
      redirectPrompt: 'Looks like you’re visiting from Canada. For the best experience, check out our dedicated MONOPOLY Casino Canada site.',
      redirectTo: `${ventures.monopolycasinoca?.urls?.url}/?acquisition-channel=referral`,
      redirectButton: 'GO TO CANADA'
    }
  },
  us: {
    monopolycasino: {
      redirectPrompt: 'Looks like you’re visiting from the U.S. For the best experience, check out our dedicated MONOPOLY Casino U.S. site.',
      redirectTo: `${ventures.monopolycasinous?.urls?.url}/?acquisition-channel=referral`,
      redirectButton: 'GO TO U.S.'
    },
    ballyuk: {
      redirectPrompt: 'Looks like you’re visiting from the U.S. For the best experience, check out our dedicated U.S. site.',
      redirectTo: `${ventures.ballycasinonj?.urls?.url}/?acquisition-channel=referral`,
      redirectButton: 'GO TO U.S.'
    },
    monopolycasinoca: {
      redirectPrompt: 'Looks like you’re visiting from the U.S. For the best experience, check out our dedicated MONOPOLY Casino U.S. site.',
      redirectTo: `${ventures.monopolycasinous?.urls?.url}/?acquisition-channel=referral`,
      redirectButton: 'GO TO U.S.'
    }
  },
  gb: {
    monopolycasinous: {
      redirectPrompt: 'Looks like you’re visiting from the UK and Ireland. For the best experience, check out your local MONOPOLY Casino site.',
      redirectTo: `${ventures.monopolycasino?.urls?.url}/?acquisition-channel=referral`,
      redirectButton: 'GO TO UK & IRELAND'
    },
    ballycasinonj: {
      redirectPrompt: 'Looks like you’re visiting from the UK and Ireland. For the best experience, check out our dedicated UK and Ireland site.',
      redirectTo: `${ventures.ballyuk?.urls?.url}/?acquisition-channel=referral`,
      redirectButton: 'GO TO UK & IRELAND'
    },
    monopolycasinoca: {
      redirectPrompt: 'Looks like you’re visiting from the UK and Ireland. For the best experience, check out our dedicated UK and Ireland site.',
      redirectTo: `${ventures.monopolycasino?.urls?.url}/?acquisition-channel=referral`,
      redirectButton: 'GO TO UK & IRELAND'
    }
  },
  gr: {
    ballycasinonj: {
      redirectPrompt: 'Looks like you’re visiting from Greece. For the best experience, check out our dedicated Greece site.',
      redirectTo: `${ventures.ballycasinogr?.urls?.url}/?acquisition-channel=referral`,
      redirectButton: 'GO TO GREECE'
    },
    ballyuk: {
      redirectPrompt: 'Looks like you’re visiting from Greece. For the best experience, check out our dedicated Greece site.',
      redirectTo: `${ventures.ballycasinogr?.urls?.url}/?acquisition-channel=referral`,
      redirectButton: 'GO TO GREECE'
    }
  }
}

export default function useGeoRedirect (queryParams) {
  const from = queryParams.get('from')?.toLowerCase() || ''

  const [showRedirectModal, setShowRedirectModal] = useState(() => {
    if (from && Object.keys(ventureGeoRedirects).includes(from)) {
      return Object.keys(ventureGeoRedirects[from]).includes(venture)
    }
    return false
  })

  const redirectConfig = ventureGeoRedirects[from]?.[venture]

  const handleRedirect = () => {
    if (redirectConfig?.redirectTo) {
      window.location.replace(redirectConfig.redirectTo)
    }
  }

  const closeRedirectModal = () => {
    setShowRedirectModal(false)
  }

  return {
    showRedirectModal,
    redirectConfig,
    handleRedirect,
    closeRedirectModal
  }
}
